import React from 'react'
import { Link } from 'react-router-dom'
import './HomePage.css'

const HomePage: React.FC = () => {
  return (
    <div className="home-page">
      <div className="welcome-hero">
        <h1 className="welcome-title">Welcome to React SPA</h1>
        <p className="welcome-subtitle">Build once, deploy many</p>
        <p className="welcome-message">
          This React SPA is built with <strong>Vite</strong> and <strong>TypeScript</strong>,
          with Harness CI/CD for build-once deploy-many and rollback from Artifactory.
        </p>
      </div>

      <div className="quick-actions">
        <div className="action-card">
          <h3>Quick Start</h3>
          <p>Run the app locally from the <code>app</code> folder.</p>
          <div className="code-snippet">
            <code>npm install && npm run dev</code>
          </div>
        </div>
        <div className="action-card">
          <h3>Deploy</h3>
          <p>Harness pipeline builds once, publishes to Artifactory, deploys to each environment.</p>
          <div className="code-snippet">
            <code>Run the Build &amp; Deploy pipeline</code>
          </div>
        </div>
        <div className="action-card">
          <h3>API Demo</h3>
          <p>Sample integration with a real public API (Frankfurter currency).</p>
          <Link to="/api-demo" className="action-button">View API Demo →</Link>
        </div>
        <div className="action-card">
          <h3>Test Route</h3>
          <p>Verify React Router is working.</p>
          <Link to="/test" className="action-button">View Test Page →</Link>
        </div>
      </div>

      <div className="features-grid">
        <div className="feature-item">
          <span className="feature-icon">⚛️</span>
          <h4>React 18</h4>
          <p>Latest React with hooks</p>
        </div>
        <div className="feature-item">
          <span className="feature-icon">📦</span>
          <h4>TypeScript</h4>
          <p>Type-safe development</p>
        </div>
        <div className="feature-item">
          <span className="feature-icon">⚡</span>
          <h4>Vite</h4>
          <p>Fast build and dev server</p>
        </div>
        <div className="feature-item">
          <span className="feature-icon">🎨</span>
          <h4>Modern CSS</h4>
          <p>Responsive layout</p>
        </div>
      </div>
    </div>
  )
}

export default HomePage